module.exports = __webpack_public_path__ + "img/06-latest-version-section.314cef98.webp";